module.exports = __webpack_public_path__ + "static/media/profile-playlists.750b015c.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/profile-playlists.png
// module id = 719
// module chunks = 0